import { ApplicationState } from "../../../types/state/storeTypes";
import { connect } from 'react-redux';

import { IntroStepProps } from "../../../types/components/user-survey/steps/IntoStep";
import { MainLinkButton } from "../../styled/buttons/MainLinkButton";

const IntroStep: React.FC<IntroStepProps> = ({ handleNext, user }) => {

return (
    <div cy-test-id="intro-step" className="flex flex-col items-center gap-[120px]">
      <div className="flex flex-col gap-[24px]">
        <h1 className="uppercase font-bold text-white text-4xl tracking-[3%] leading-[55px] text-center">Exciting things are in the works</h1>
        <p className="text-a-light-gray max-w-[600px] text-center">Hey<span className='capitalize'>{user?.first_name ? ' ' + user?.first_name : null}</span>, we've got some ideas about tutorials and courses that could empower VFX artists but we want to know what you need most.</p>
      </div>
      <MainLinkButton className="!w-11/12 lg:!w-[330px]" variant='blue' size='large' onClick={handleNext}>Lets begin!</MainLinkButton>      
    </div>
  )
}

const mapStateToProps = (state: ApplicationState) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(IntroStep);